<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          주문내역 상세
        </h5>
        <div class="col-lg-6 offset-lg-3">
        <div class="flex_center">
          <button
            class="btn btn-success"
            @click="getExcel()"
          >
            <i class="fas fa-file-excel" style="margin-right: 5px"></i>엑셀저장
          </button>
          <slot name="actions" :records="records" />
        </div>
      </div>
        <div style="margin: 10px">
          총 건수 : <span style="font-weight: bold">{{ total }}</span>건
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>이름</th>
              <th>아이디</th>
              <th>소속</th>
              <th>종료일</th>
              <th>상품명</th>
              <th>결제방법</th>
              <th>금액</th>
              <th>결제일시</th>
              <th>상태</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(subscription, index) in subscriptions" :key="subscription.id">
              <td>{{ total - ((currentPage - 1) * itemsPerPage + index) }}</td>
              <td>{{ subscription.hanName }}</td>
              <td>{{ subscription.username }}</td>
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="subscription.p_biz" :biz="subscription.p_biz" />
              </td>
              <td>{{ subscription.endDate }}</td>              
              <td style="font-size: 12px">{{ subscription.productName }}</td>
              <td>
                <template v-if="subscription.paymentMethod === 'CARD_ONPG'">
                  <span
                    style="font-size: 10px; background: #00acea; padding: 2px 4px; color: #fff; border-radius: 4px; border: 1px solid #0095ea;"
                  ><i class="fa-regular fa-credit-card"></i>&nbsp;카드</span>
                </template>
                <template v-if="subscription.paymentMethod === 'CARD_OFFPG'">
                  <span
                    style="font-size: 10px; background: #009aea; padding: 2px 4px; color: #fff; border-radius: 4px; border: 1px solid #0095ea;"
                  ><i class="fa-brands fa-cc-visa"></i>&nbsp;카드(오프)</span>
                </template>
                <template v-if="subscription.paymentMethod === 'CASH'">
                  <span
                    style="font-size: 10px; background: #eb4e4e; padding: 2px 4px; color: #fff; border-radius: 4px; border: 1px solid #e92222;"
                  ><i class="fa-solid fa-coins"></i>&nbsp;현금</span>
                </template>
              </td>
              <td style="font-size: 12px">
                {{ parseInt(subscription.price).toLocaleString() }}원
              </td>
              <td>{{ subscription.payAt }}</td>
              
              <td>
                <span v-if="subscription.status === 'WAITING_PAYMENT'">
                  <span class="btn-success btn-sm">결제대기</span><br />
                  <span style="font-size: 12px; color: #d61518" v-if="!subscription.previous_order">
                    {{ subscription.startDate.substr(2, 8) }}
                  </span>
                </span>
                <span v-if="subscription.status === 'PAYMENT_LATE'">
                  <span class="btn-secondary btn-sm">결제만료</span>
                </span>
                <span v-if="subscription.status === 'ACTIVE'">
                  <span class="btn-primary btn-sm">사용중</span>
                </span>
                <span v-if="subscription.status === 'PENDING'">
                  <span class="btn-warning btn-sm">대행대기</span><br />
                  <span style="font-size: 12px; color: #d61518" v-if="!subscription.previous_order">
                    {{ subscription.startDate.substr(2, 8) }}
                  </span>
                </span>
                <span v-if="subscription.status === 'ENDED'">
                  <span class="btn-dark btn-sm">만료됨</span>
                </span>
                <span v-if="subscription.status === 'CANCELLED'">
                  <span class="btn-danger btn-sm">취소됨</span><br />
                  <span style="font-size: 12px; color: #d61518" v-if="subscription.cancel_request_date">
                    {{ subscription.cancel_request_date.substr(2, 8) }}
                  </span>
                </span>
                <span v-if="subscription.status === 'RESERVED'">
                  <span class="btn-warning btn-sm">연장</span>
                </span>
                <span v-if="subscription.status === 'CONFIRMING_PAYMENT'">
                  <span class="btn-warning btn-sm">결제확인중</span><br />
                  <span style="font-size: 12px; color: #d61518" v-if="!subscription.previous_order">
                    {{ subscription.startDate.substr(2, 8) }}
                  </span>
                </span>
                <span v-if="subscription.status === 'CANCEL_PENDING'">
                  <span class="btn-warning btn-sm">취소 대기중</span><br />
                  <span style="font-size: 12px; color: #d61518" v-if="subscription.cancel_request_date">
                    {{ subscription.cancel_request_date.substr(2, 8) }}
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        
        <!-- Pagination Component -->
        <div style="display: flex; align-items: center; justify-content: center">
          <v-pagination
            v-model="currentPage"
            :pages="totalPages"
            :range-size="3"
            active-color="#DCEDFF"
            @update:modelValue="onPageChange"
          />
          <select
            v-model="itemsPerPage"
            @change="onItemsPerPageChange"
            style="
              padding: 4px;
              font-size: 12px;
              border: 1px solid #ccc;
              margin-left: 10px;
            "
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import Business from "../Business";

export default {
  components: {
    VPagination,
    Business,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    cateFilterMain: {
      type: String,
      required: false,
      default: "",
    },
    cateFilterSub: {
      type: String,
      required: false,
      default: "",
    },
    paymethodFilter: Array,
    dateFilter: {
      type: Object,
      required: false,
      default: () => ({ start: "", end: "" }),
    },
  },
  data() {
    return {
      subscriptions: [],
      total: 0,              // 전체 항목 수
      currentPage: 1,        // 현재 페이지
      itemsPerPage: 20,      // 페이지당 항목 수
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.itemsPerPage);  // 전체 페이지 수 계산
    },
  },
  watch: {
    article: {
      handler: 'fetchDetails',
      immediate: true
    },
    cateFilterMain: {
      handler: 'fetchDetails',
      immediate: true
    },
    cateFilterSub: {
      handler: 'fetchDetails',
      immediate: true
    },
    dateFilter: {
      handler: 'fetchDetails',
      immediate: true,
      deep: true
    }
  },
  methods: {
    fetchDetails() {
      const offset = (this.currentPage - 1) * this.itemsPerPage;
      axios.get("/admin/stat_sales/details", {
        params: {
          cate_filter_main: this.cateFilterMain,
          cate_filter_sub: this.cateFilterSub,
          date_filter: this.dateFilter,
          date_filter_start: this.dateFilter.start,
          date_filter_end: this.dateFilter.end,
          paymethod_filter: this.paymethodFilter,
          limit: this.itemsPerPage,
          offset: offset,
        },
      })
      .then((response) => {
        if (response.data.status === "ok") {
          this.subscriptions = response.data.result;
          this.total = response.data.total;
        } else {
          console.error("데이터 로드 실패:", response.data.error);
        }
      })
      .catch((error) => {
        console.error("API 호출 오류:", error);
      });
    },
    onPageChange(pageNumber) {
      this.currentPage = pageNumber;   // 페이지가 변경되었을 때 처리
      this.fetchDetails();             // 새로운 페이지 데이터 로드
    },
    onItemsPerPageChange() {
      this.currentPage = 1;            // 페이지당 항목 수 변경 시 첫 페이지로 이동
      this.fetchDetails();             // 새로운 페이지 데이터 로드
    },
    async getExtras(include_paging) {
      let extras = include_paging
        ? `?limit=${this.itemsPerPage}&offset=${(this.currentPage - 1) * this.itemsPerPage}`
        : "?";
      
      // 필터 필드를 바탕으로 추가 쿼리 문자열 생성
      if (this.cateFilterMain) extras += `&cate_filter_main=${this.cateFilterMain}`;
      if (this.cateFilterSub) extras += `&cate_filter_sub=${this.cateFilterSub}`;
      if (this.dateFilter.start) extras += `&date_filter_start=${this.dateFilter.start}`;
      if (this.dateFilter.end) extras += `&date_filter_end=${this.dateFilter.end}`;
      if (this.paymethodFilter.length) {
        this.paymethodFilter.forEach((method) => {
          extras += `&paymethod_filter[]=${encodeURIComponent(method)}`;
        });
      }
      return extras;
    },

    // Excel 파일 생성 및 다운로드
    async getExcel() {
      try {
        const extras = await this.getExtras(false);
        const response = await axios.get(`/admin/stat_sales/details${extras}&limit=2147483647&offset=0`);

        if (response.data.status === "ok") {
          let csv =
            '<meta http-equiv="Content-Type" content="application/vnd.ms-excel; charset=UTF-8" /><head><style>td{mso-number-format: "@";}</style><body><table><tr>';
          
          // CSV 파일의 헤더 추가
          csv += "<th>No</th><th>이름</th><th>아이디</th><th>소속</th><th>종료일</th><th>상품명</th><th>결제방법</th><th>금액</th><th>결제일시</th><th>상태</th></tr>";

          const records = response.data.result;

          // 각 데이터를 CSV 형식으로 변환
          records.forEach((data, index) => {
            csv += "<tr>";
            csv += `<td>${index + 1}</td>`;
            csv += `<td>${data.hanName}</td>`;
            csv += `<td>${data.username}</td>`;
            csv += `<td>${data.p_biz.name || ''}</td>`;
            csv += `<td>${data.endDate}</td>`;
            csv += `<td>${data.productName}</td>`;
            csv += `<td>${data.paymentMethod === "CARD_ONPG" ? "카드(ON)" : data.paymentMethod === "CARD_OFFPG" ? "카드(OFF)" : "현금"}</td>`;
            csv += `<td>${parseInt(data.price).toLocaleString()}원</td>`;
            csv += `<td>${data.payAt}</td>`;
            csv += `<td>${this.getStatusText(data.status)}</td>`;
            csv += "</tr>";
          });

          csv += "</table></body>";
          
          const filename = "주문내역 상세" +
              " (" +
              new Date() +
              ")"  +
              ".xls";
          const blob = new Blob([csv], { type: "text/xls" });
          const elem = document.createElement("a");
          elem.href = URL.createObjectURL(blob);
          elem.download = filename;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        } else {
          console.error("엑셀 데이터를 가져오는 데 실패했습니다:", response.data.error);
        }
      } catch (error) {
        console.error("엑셀 파일 다운로드 중 오류 발생:", error);
      }
    },

    // 상태 텍스트 반환 함수
    getStatusText(status) {
      switch (status) {
        case 'WAITING_PAYMENT': return '결제대기';
        case 'PAYMENT_LATE': return '결제만료';
        case 'ACTIVE': return '사용중';
        case 'PENDING': return '대행대기';
        case 'ENDED': return '만료됨';
        case 'CANCELLED': return '취소됨';
        case 'RESERVED': return '연장';
        case 'CONFIRMING_PAYMENT': return '결제확인중';
        case 'CANCEL_PENDING': return '취소 대기중';
        default: return '';
      }
    },
  },
  
};
</script>
